import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/payment-methods.php';

const sub_service_path = '/get-index-by-user-id.php';

export function getPaymentMethods() {

    const response = api.get(service_path);

    return response;
};

export function getPaymentMethodDetails(id, setData) {

    api.get(`${service_path}?id=${id}`)
        .then(response => {

            const { data } = response;

            if (data.success) {
                setData(data.data);
            } else {
                globalToast.error('Houve um erro ao carregar o conteúdo desta página!');
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao carregar o conteúdo desta página!');
        });
};

export function createPaymentMethod(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Conforto cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updatePaymentMethod(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Método de pagamento editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function getIndexByUserId(id) {

    const response = api.get(sub_service_path + `?id=${id}`);

    return response;
};

export function deletePaymentMethod(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Método de pagamento deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar o método de pagamento!');
            };
        });
};